/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IReferral } from './referralSlice.types';

const initialState: IReferral = {
  referralData: {}
};

export const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    setReferralData: (state: IReferral, action: PayloadAction<any>) => {
      const { payload } = action;
      state.referralData = payload;
    }
  }
});

const { actions, reducer } = referralSlice;
export const { setReferralData } = actions;
export default reducer;
